import React, { createContext, useEffect, useReducer } from "react";


import { CircularProgress } from "@mui/material";

const initialState = {
    isInitialised: false,
    municipality: {
        NameEl: "ΔΗΜΟΣ ΚΟΜΟΤΗΝΗΣ",
        MunicipalityId: 3,
        CenterLatitude: 41.116261,
        LocalityEn:"Komotini",
        CenterLongitude: 25.406729,
        RecycleBucketText:"<>NULL<>"
    },
};

const setSession = (municipalityData) => {
    if (municipalityData) {
        localStorage.setItem(
            "app_selected_municipality",
            JSON.stringify(municipalityData)
        );
    } else {
        localStorage.removeItem("app_selected_municipality");
    }
};

const reducer = (state, action) => {
    switch (action.type) {
        case "INIT": {
            const { municipality } = action.payload;

            return {
                ...state,
                isInitialised: true,
                municipality,
            };
        }
        case "CREATE": {
            const { municipality } = action.payload;

            return {
                ...state,
                isInitialised: false,
                municipality,
            };
        }

        default: {
            return { ...state };
        }
    }
};

const MunicipalityContext = createContext({
    ...initialState,
    init: () => {
        
     },
});

export const MunicipalityProvider = ({ children }) => {
    const [state, dispatch] = useReducer(reducer, initialState);

    const init = async (municipality) => {
        
        setSession(municipality);

        dispatch({
            type: "INIT",
            payload: {
                municipality: municipality,
            },
        });
    };

    useEffect(() => {
        (async () => {
            try {
                const savedMunicipality = window.localStorage.getItem(
                    "app_selected_municipality"
                );

                if (savedMunicipality) {
                    dispatch({
                        type: "INIT",
                        payload: {
                            municipality: JSON.parse(savedMunicipality),
                        },
                    });
                } else {
                    dispatch({
                        type: "INIT",
                        payload: {
                            municipality: {
                                NameEl: "ΔΗΜΟΣ ΚΟΜΟΤΗΝΗΣ",
                                MunicipalityId: 3,
                                LocalityEn:"Komotini",
                                RecycleBucketText:"null"
                                
                            },
                        },
                    });
                }
            } catch (err) {
                console.error(err);
            }
        })();
    }, []);

    if (!state.isInitialised) {
        return <CircularProgress></CircularProgress>;
    }

    return (
        <MunicipalityContext.Provider
            value={{
                ...state,
                init,
            }}
        >
            {children}
        </MunicipalityContext.Provider>
    );
};

export default MunicipalityContext;
